import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { TbWorld } from 'react-icons/tb';

import ChromeSvg from '@/assets/navegators/Chrome.svg';
import FirefoxSvg from '@/assets/navegators/Firefox.svg';
import SafariSvg from '@/assets/navegators/Safari.svg';
import OperaSvg from '@/assets/navegators/Opera.svg';
import EdgePng from '@/assets/navegators/Edge.png';

interface BrowserIconProps {
  className?: string;
  size?: number;
}

export function ChromeIcon({ className = "", size = 32 }: BrowserIconProps) {
  useLanguage();
  return <img src={ChromeSvg} alt={translateInterfaceText("Chrome")} width={size} height={size} className={className} />;
}

export function SafariIcon({ className = "", size = 32 }: BrowserIconProps) {
  useLanguage();
  return <img src={SafariSvg} alt={translateInterfaceText("Safari")} width={size} height={size} className={className} />;
}

export function FirefoxIcon({ className = "", size = 32 }: BrowserIconProps) {
  useLanguage();
  return <img src={FirefoxSvg} alt={translateInterfaceText("Firefox")} width={size} height={size} className={className} />;
}

export function EdgeIcon({ className = "", size = 32 }: BrowserIconProps) {
  useLanguage();
  return <img src={EdgePng} alt={translateInterfaceText("Edge")} width={size} height={size} className={className} />;
}

export function OperaIcon({ className = "", size = 32 }: BrowserIconProps) {
  useLanguage();
  return <img src={OperaSvg} alt={translateInterfaceText("Opera")} width={size} height={size} className={className} />;
}

export function BraveIcon({ className = "", size = 32 }: BrowserIconProps) {
  useLanguage();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="none"
    >
      <path
        d="M20.09 7.06L21 4.5l-1.67-.5-.83 1.08a9.77 9.77 0 00-1.16-.44L17 3H7l-.34 1.64a9.77 9.77 0 00-1.16.44L4.67 4 3 4.5l.91 2.56A8.5 8.5 0 002.5 12c0 2.74 1.3 5.18 3.32 6.75L7.5 21h9l1.68-2.25A8.49 8.49 0 0021.5 12a8.5 8.5 0 00-1.41-4.94z"
        fill="#FB542B"
      />
      <path
        d="M14.5 10.5l1-2-2 .5-1.5-1.5-1.5 1.5-2-.5 1 2-1.5 3 2.5 2.5h3l2.5-2.5-1.5-3z"
        fill="#fff"
      />
    </svg>
  );
}

export function OtherBrowserIcon({ className = "", size = 24 }: BrowserIconProps) {
  useLanguage();
  return <TbWorld className={className} size={size} style={{ color: '#1e2d48' }} />;
}

// Helper function to get browser icon by name
export function getBrowserIconComponent(browserName: string, size: number = 32) {
  const name = browserName.toLowerCase();

  if (name.includes('chrome') || name.includes('chromium')) {
    return <ChromeIcon size={size} />;
  }

  if (name.includes('safari')) {
    return <SafariIcon size={size} />;
  }

  if (name.includes('firefox')) {
    return <FirefoxIcon size={size} />;
  }

  if (name.includes('edge') || name.includes('edg')) {
    return <EdgeIcon size={size} />;
  }

  if (name.includes('opera') || name.includes('opr')) {
    return <OperaIcon size={size} />;
  }

  if (name.includes('brave')) {
    return <BraveIcon size={size} />;
  }

  return <OtherBrowserIcon size={size} />;
}
